import httpClient from "@/helpers/httpClient";
import axios from "axios";

export function getSkins() {
  return axios.get(`${process.env.VUE_APP_BACKEND_API_URL}/skins`);
}
